<template>
  <v-row>
    <v-col cols="6" xs="6" class="text-left pb-0 mb-0">
      <v-btn
        x-small elevation="10"
        class="text-xs font-weight-semibold"
        color="info darken-2"
        :to="{ name: 'savings.create_client' }"
      >
        <font-awesome-icon icon="fa-solid fa-eye" class="pe-1" />
        Create a Client
      </v-btn>
    </v-col>
    <v-col cols="6" xs="6" class="text-right pb-0 mb-0">
      <v-btn
        x-small elevation="10"
        class="text-xs font-weight-semibold"
        color="primary darken-2"
        :to="{ name: 'savings.clients_create_zone' }"
      >
        <font-awesome-icon icon="fa-solid fa-plus" class="pe-1" />
        Create a Zone
      </v-btn>
    </v-col>

    <!-- DIALOG 1 : Choix de la langue -->
    <v-dialog v-model="langDialog" max-width="320">
      <v-card>
        <v-card-title class="text-h6 justify-center pt-4">
          💬 Send message in...
        </v-card-title>
        <v-card-text class="text-center">
          Choose the language for the WhatsApp message:
        </v-card-text>
        <v-card-actions class="justify-center pb-5">
          <v-btn color="primary" @click="showPreview('en')">🇬🇧 English</v-btn>
          <v-btn color="success" class="ml-3" @click="showPreview('fr')">🇫🇷 Français</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG 2 : Aperçu WhatsApp -->
    <v-dialog v-model="previewDialog" max-width="480">
      <v-card>
        <div style="background:#075E54; padding:12px 16px; display:flex; align-items:center; gap:12px; border-radius:4px 4px 0 0;">
          <div style="width:40px; height:40px; border-radius:50%; background:#25D366; display:flex; align-items:center; justify-content:center; font-weight:600; font-size:14px; color:#fff; flex-shrink:0;">
            {{ pendingItem ? initials(pendingItem.username) : '' }}
          </div>
          <div>
            <div style="color:#fff; font-size:15px; font-weight:500; line-height:1.2;">
              {{ pendingItem ? pendingItem.username : '' }}
            </div>
            <div style="color:#B2DFDB; font-size:12px;">
              {{ pendingItem ? pendingItem.phone_number : '' }}
            </div>
          </div>
          <v-spacer />
          <font-awesome-icon icon="fa-solid fa-phone" style="color:#B2DFDB; font-size:18px;" />
        </div>
        <div style="background:#E5DDD5; padding:16px; min-height:260px;">
          <div style="display:flex; justify-content:flex-end;">
            <div
              style="background:#DCF8C6; border-radius:8px 0 8px 8px; padding:10px 13px; max-width:90%; font-size:13px; color:#111; line-height:1.65; box-shadow:0 1px 1px rgba(0,0,0,0.12);"
              v-html="previewBubble"
            ></div>
          </div>
        </div>
        <v-card-actions class="px-4 pb-4 pt-2">
          <v-btn text @click="previewDialog = false; langDialog = true">
            <font-awesome-icon icon="fa-solid fa-arrow-left" class="me-1" /> Back
          </v-btn>
          <v-spacer />
          <v-btn color="success" @click="sendToWhatsApp()">
            <font-awesome-icon icon="fa-solid fa-paper-plane" class="me-2" />
            Open in WhatsApp
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Tableau principal -->
    <v-col cols="12">
      <v-card>
        <v-row class="mt-2 mx-2 pt-0">
          <v-col cols="12" class="px-4 pt-2 mt-1 mb-0 pb-0">
            <v-select
              v-model="selectedZoneFilter"
              ref="selectedZoneFilter"
              outlined dense
              item-value="id"
              item-text="info"
              :items="zone_types"
              label="Filter Clients By Zone"
              @change="getClients"
            ></v-select>
          </v-col>
          <v-col cols="6" xs="6" class="text-left mt-0 pt-0">
            <v-text-field
              v-model="selectedStartDate"
              dense type="date"
              label="Start Date"
              clearable
              @change="getClients"
            ></v-text-field>
          </v-col>
          <v-col cols="6" xs="6" class="text-right mt-0 pt-0">
            <v-text-field
              v-model="selectedEndDate"
              dense type="date"
              label="End Date"
              clearable
              @change="getClients"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-card-title class="mt-0 pt-0">
          <span class="me-3">({{ requestedClients.length }}) List Of Clients</span>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="requestedClients"
          item-key="id"
          class="table-rounded"
          :items-per-page="10"
          disable-sort
          :search="search"
          :loading="loading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:progress>
            <v-progress-linear
              v-if="loading"
              indeterminate
              color="primary"
            ></v-progress-linear>
          </template>

          <template #[`item.username`]="{item}">
            <div class="d-flex flex-column" style="cursor: pointer">
              <router-link
                :to="'/savings/clients/profile/account-settings/'+item.id"
                class="d-block font-weight-semibold text--primary text-truncate"
              >
                {{ item.username }}
              </router-link>
              <small>
                {{ item.no_campaigns }} (Saved: {{ item.amount_saved_so_far }})  & {{ item.no_loans }} (Paid: {{ item.amount_paid_so_far }})
              </small>
            </div>
          </template>

          <template #[`item.status`]="{item}">
            <v-chip small :color="statusColor[item.status]" class="font-weight-medium">
              {{ item.status }}
            </v-chip>
          </template>

          <template #[`item.phone_number`]="{item}">
            <v-btn class="success" elevation="6" icon small @click="promptLang(item)">
              <font-awesome-icon icon="fa-solid fa-comments" />
            </v-btn>
          </template>

          <template #[`item.date_time`]="{item}">
            {{ item.date_time }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mdiSquareEditOutline, mdiDotsVertical } from '@mdi/js'
import axios from 'axios'
import _ from 'lodash'

export default {
  components: {},
  data() {
    const statusColor = {
      Active: 'primary',
      Validated: 'success',
      Inactive: 'error',
    }
    return {
      headers: [
        { text: 'Name', value: 'username' },
        { text: 'Principal Campaign', value: 'amount' },
        { text: 'Loan Target', value: 'amount_owed_so_far' },
        { text: 'Savings Target', value: 'amount_savings_target_so_far' },
        { text: 'Status', value: 'status' },
        { text: 'Chat', value: 'phone_number' },
        { text: 'Date/Time', value: 'date_time' },
      ],
      selectedZoneFilter: "",
      zone_types: [],
      requestedClients: [],
      statusColor,
      search: '',
      selectedStartDate: null,
      selectedEndDate: null,
      loading: false,
      debouncedGetClients: null,

      // Dialogs
      langDialog: false,
      previewDialog: false,
      pendingItem: null,
      selectedLang: 'en',
      previewBubble: '',

      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
      },
    }
  },

  mounted() {
    document.title = "Manager: Savings | List of Clients"
    this.debouncedGetClients = _.debounce(this.getClients, 500)
    this.getZones().then(() => {
      if (this.selectedZoneFilter) this.getClients()
    })
  },

  watch: {
    selectedStartDate() {
      if (this.selectedZoneFilter) this.debouncedGetClients()
    },
    selectedEndDate() {
      if (this.selectedZoneFilter) this.debouncedGetClients()
    },
    selectedZoneFilter(newVal) {
      if (newVal) this.debouncedGetClients()
    },
  },

  methods: {
    // ─── Utilitaires ───────────────────────────
    initials(name = '') {
      return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
    },

    // ─── Dialogue WhatsApp ─────────────────────
    promptLang(item) {
      this.pendingItem = item
      this.langDialog = true
    },

    showPreview(lang) {
      this.langDialog = false
      this.selectedLang = lang
      this.previewBubble = this.buildBubbleHtml(this.pendingItem, lang)
      this.previewDialog = true
    },

    sendToWhatsApp() {
      this.previewDialog = false
      window.open(this.buildWhatsAppUrl(this.pendingItem, this.selectedLang), '_blank')
      this.pendingItem = null
    },

    // ─── Construction des messages ─────────────
    buildBubbleHtml(item, lang) {
      if (!item) return ''
      const fr = lang === 'fr'
      const username = item.username || '—'
      // Utilisation des nouveaux champs numériques
      const savings = item.campaign_count ?? 0
      const njangi  = item.njangi_group_count ?? 0
      const market  = item.marketplace_order_count ?? 0

      const greeting = fr
        ? `<p style="margin:0 0 6px">Bonjour <b>${username}</b> 😃,</p><p style="margin:0 0 8px">J'espère que vous passez une excellente journée ! 💫</p>`
        : `<p style="margin:0 0 6px">Greetings <b>${username}</b> 😃,</p><p style="margin:0 0 8px">I hope you're having a wonderful day! 💫</p>`

      const intro = fr
        ? `Je fais partie de l'équipe PettyCash et j'aimerais partager avec vous un rapide point sur votre compte :`
        : `I'm a member of the PettyCash team, and I'd like to share a quick update on your account:`

      const stats = fr
        ? `📊 <b>État actuel du compte</b><br>• Campagnes d'épargne : <b>${savings}</b><br>• Groupes Njangi : <b>${njangi}</b><br>• Activité Marketplace : <b>${market}</b>`
        : `📊 <b>Current Account Status</b><br>• Savings Campaign: <b>${savings}</b><br>• Njangi Groups: <b>${njangi}</b><br>• Marketplace Activity: <b>${market}</b>`

      const notice = (savings === 0 && njangi === 0 && market === 0)
        ? (fr
          ? `Il semble que vous n'ayez pas encore créé de campagne d'épargne ni commencé à utiliser nos services Njangi ou Marketplace.`
          : `It looks like you haven't created a savings campaign or started using our Njangi or Marketplace services yet.`)
        : ''

      const help = fr
        ? `Nous sommes là pour vous aider à démarrer et à tirer le meilleur parti de PettyCash. Si vous avez des questions ou besoin d'assistance pour lancer votre première campagne d'épargne ou explorer nos services, n'hésitez pas.`
        : `We're here to help you get started and make the most of PettyCash. If you have any questions, concerns, or need assistance with setting up your first savings campaign or exploring our services, we'd be happy to assist.`

      const linkLine = fr
        ? `💬 Commencez une conversation avec notre équipe ici :<br>https://myapp.pettycashglobal.com/`
        : `💬 Start a conversation with our team here:<br>https://myapp.pettycashglobal.com/`

      const closing = fr
        ? `Au plaisir de vous lire !<br><br>Cordialement,<br><b>L'équipe PettyCash</b>`
        : `We look forward to hearing from you!<br><br>Best regards,<br><b>The PettyCash Team</b>`

      const timestamp = fr
        ? `<p style="text-align:right; margin:8px 0 0; font-size:11px; color:#888;">Aperçu ✓✓</p>`
        : `<p style="text-align:right; margin:8px 0 0; font-size:11px; color:#888;">Preview ✓✓</p>`

      let html = `${greeting}<p style="margin:0 0 8px">${intro}</p>`
      html += `<p style="margin:0 0 10px">${stats}</p>`
      if (notice) html += `<p style="margin:0 0 8px">${notice}</p>`
      html += `<p style="margin:0 0 8px">${help}</p>`
      html += `<p style="margin:0 0 8px">${linkLine}</p>`
      html += `<p style="margin:0 0 6px">${closing}</p>`
      html += timestamp
      return html
    },

    buildWhatsAppUrl(item, lang) {
      if (!item) return '#'
      const fr = lang === 'fr'
      const phone = String(item.phone_number || '').length === 9
        ? '237' + item.phone_number
        : item.phone_number
      const username = item.username || '—'
      const savings = item.campaign_count ?? 0
      const njangi  = item.njangi_group_count ?? 0
      const market  = item.marketplace_order_count ?? 0

      let lines = []
      if (fr) {
        lines.push(`Bonjour *${username}* 😃,`)
        lines.push(`J'espère que vous passez une excellente journée ! 💫`)
        lines.push(``)
        lines.push(`Je fais partie de l'équipe PettyCash et j'aimerais partager avec vous un rapide point sur votre compte :`)
        lines.push(``)
        lines.push(`📊 *État actuel du compte*`)
        lines.push(`• Campagnes d'épargne : *${savings}*`)
        lines.push(`• Groupes Njangi : *${njangi}*`)
        lines.push(`• Activité Marketplace : *${market}*`)
        if (savings === 0 && njangi === 0 && market === 0) {
          lines.push(``)
          lines.push(`Il semble que vous n'ayez pas encore créé de campagne d'épargne ni commencé à utiliser nos services Njangi ou Marketplace.`)
        }
        lines.push(``)
        lines.push(`Nous sommes là pour vous aider à démarrer et à tirer le meilleur parti de PettyCash. Si vous avez des questions ou besoin d'assistance pour lancer votre première campagne d'épargne ou explorer nos services, n'hésitez pas.`)
        lines.push(``)
        lines.push(`💬 Commencez une conversation avec notre équipe ici :`)
        lines.push(`https://myapp.pettycashglobal.com/`)
        lines.push(``)
        lines.push(`Au plaisir de vous lire !`)
        lines.push(``)
        lines.push(`Cordialement,`)
        lines.push(`*L'équipe PettyCash*`)
      } else {
        lines.push(`Greetings *${username}* 😃,`)
        lines.push(`I hope you're having a wonderful day! 💫`)
        lines.push(``)
        lines.push(`I'm a member of the PettyCash team, and I'd like to share a quick update on your account:`)
        lines.push(``)
        lines.push(`📊 *Current Account Status*`)
        lines.push(`• Savings Campaign: *${savings}*`)
        lines.push(`• Njangi Groups: *${njangi}*`)
        lines.push(`• Marketplace Activity: *${market}*`)
        if (savings === 0 && njangi === 0 && market === 0) {
          lines.push(``)
          lines.push(`It looks like you haven't created a savings campaign or started using our Njangi or Marketplace services yet.`)
        }
        lines.push(``)
        lines.push(`We're here to help you get started and make the most of PettyCash. If you have any questions, concerns, or need assistance with setting up your first savings campaign or exploring our services, we'd be happy to assist.`)
        lines.push(``)
        lines.push(`💬 Start a conversation with our team here:`)
        lines.push(`https://myapp.pettycashglobal.com/`)
        lines.push(``)
        lines.push(`We look forward to hearing from you!`)
        lines.push(``)
        lines.push(`Best regards,`)
        lines.push(`*The PettyCash Team*`)
      }

      const text = lines.map(l => encodeURIComponent(l)).join('%0a')
      return `https://api.whatsapp.com/send?phone=${phone}&text=${text}`
    },

    // ─── API ──────────────────────────────────
    async getZones() {
      return await axios
        .get('/api/v1/manager/get/topup/zones/')
        .then(response => {
          this.zone_types = response.data
          if (this.zone_types.length > 0 && !this.selectedZoneFilter) {
            this.selectedZoneFilter = this.zone_types[0].id
          }
        })
        .catch(error => {
          this.showError(error)
        })
    },

    async getClients() {
      if (this.selectedZoneFilter === '') {
        this.$store.commit('setSnackBarMessage', "Please select a zone")
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
        this.$refs.selectedZoneFilter.focus()
        return
      }
      const startDate = this.selectedStartDate || 'null'
      const endDate = this.selectedEndDate || 'null'
      this.loading = true
      await axios
        .get(`/api/v1/manager/get/clients/${this.selectedZoneFilter}/${startDate}/${endDate}/`)
        .then(response => {
          this.requestedClients = response.data.clients || []
          if (response.data.metadata) {
            console.log("Metadata:", response.data.metadata)
          }
        })
        .catch(error => {
          this.showError(error)
          this.requestedClients = []
        })
      this.loading = false
    },

    showError(error) {
      if (error.response) {
        this.$store.commit('setSnackBarMessage', `${error.response.status} ${error.response.statusText}`)
      } else {
        this.$store.commit('setSnackBarMessage', "An error occurred, please check your internet connection and try again later.")
      }
      this.$store.commit('setSnackBarColor', "red darken-4")
      this.$store.commit('activateSnackBar', true)
    },
  },
}
</script>
